import { SET_SEARCH_RESULTS, RETRIEVE_RECORDS_STARTED } from '../actions/search';

export default function (state = {}, action) {
  switch (action.type) {
  case SET_SEARCH_RESULTS: {
    const { requirementsSets, meta } = { ...action };

    return {
      ...state,
      isSearching: false,
      requirementsSets: requirementsSets,
      meta: meta
    };
  }
  case RETRIEVE_RECORDS_STARTED: {
    const changes = { isSearching: true };
    if (action.requestReference) changes.requestReference = action.requestReference;
    return { ...state, ...changes };
  }
  default:
    return state;
  }
}
